import { FDAvatar, FDPaper, FDStack } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import MetaControl from 'Components/UI/Meta/MetaControl';
import fr from 'facet-rest';
import metaOverrideSet from './MetaOverrideSet';


export const ClientRiskToleranceSummary = ({ resource }) => {
  return (
    <FDPaper color={'subtle'} appearance={'flat'} padding={2}>
      <FDStack spacing={1} alignItems={'center'}>
        {resource.withRelationship(fr.relationships.image.name,
          (rel) => <FDAvatar src={rel.link('related').url()} alt={'profile image'} />,
          () => null)}
        <FDStack direction={'column'} spacing={1}>
          <MetaControl resource={resource} metaOverrideSet={metaOverrideSet} attrName={'primaryText'} />
          <MetaControl resource={resource} metaOverrideSet={metaOverrideSet} attrName={'secondaryText'} />
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

ClientRiskToleranceSummary.propTypes = {
  resource: PropTypes.object.isRequired, // A DetailListItem resource
};
